
window.addEventListener('DOMContentLoaded', function() {
  const links = document.links;
  const linksLength = links.length;
  for (let i = 0; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
});



  // id="header-sidebar-menu"内の指定のhref属性値を持つ<a>要素を取得
  const specificLink = document.querySelector('.top_page_body #header-sidebar-menu a[href="https://www.nishikawa-store.com/#reason"]');

  // 特定の<a>要素が存在する場合にtarget属性を追加
  if (specificLink) {
    specificLink.setAttribute("target", "parent");

    // 特定の<a>要素が存在する場合にイベントリスナーを追加
    specificLink.addEventListener("click", function (e) {
      e.preventDefault(); // リンクのデフォルトの動作をキャンセル
      window.location.hash = "reason"; // ページ内遷移を行う
      location.reload(); // ページをリフレッシュ
    });
  }


// 画面幅が1149px以下の場合に実行
if (window.innerWidth <= 1149) {
  // #header-sidebar-menu内のhref属性が"/pages/reasons-for-selection2"のリンクを取得
  const linkToChange = document.querySelector('#header-sidebar-menu a[href="/pages/reasons-for-selection2"]');

  // リンクが存在する場合、href属性を"/pages/reasons-for-selection"に書き換える
  if (linkToChange) {
    linkToChange.setAttribute('href', '/pages/reasons-for-selection');
  }
}




window.addEventListener('load', function() {
$(function() {
    if($('.exp_tabs').length){
	// 初期表示
	$(".exp_tab_content").hide();

	// 各タブセットに対して初期設定
	$(".exp_tabs").each(function() {
		$(this).find("li:first").addClass("active").show();
		$(this).closest('.exp_tab_wrap').find(".exp_tab_content:first").show();
	});

	// タブクリック時
	$("ul.exp_tabs li").click(function() {
		var parentWrap = $(this).closest('.exp_tab_wrap');
		
		parentWrap.find('ul.exp_tabs li').removeClass("active");
		$(this).addClass("active");
		
		// そのタブセット内のコンテンツを非表示
		parentWrap.find(".exp_tab_content").hide();

		// クリックされたタブのインデックスに基づいて対応するコンテンツを表示
		var index = $(this).index();
		parentWrap.find(".exp_tab_content").eq(index).fadeIn('fast');

		return false;
	});
          }
});
});